<div
  [class]="
    'flex flex-col items-center justify-center gap-6 ' +
    (isEntryVariant() ? 'fixed inset-0 z-50' : 'h-full px-(--page-padding-x)')
  "
  [ngStyle]="containerStyle()"
  animate.enter="animate-fade-in"
  animate.leave="animate-fade-out"
>
  @if (lottieUrl()) {
    <ng-lottie
      [options]="lottieOptions()"
      [class]="isEntryVariant() ? 'w-full max-w-80' : 'w-8 h-8'"
    />
  }
  @if (config().text) {
    <app-dynamic
      componentName="DynamicText"
      [props]="{ config: config().text }"
    />
  }
</div>
